import { NgModule } from '@angular/core';
import {
    FareOptimisationRejectFormComponent
} from "./fare-optimisation-reject-form.component";
import { CommonModule } from "@angular/common";
import { MatDialogModule } from "@angular/material/dialog";
import { BtnModule } from "libraries/ui_button/btn.module";
import { CardModule } from "libraries/ui_card/card.module";
import { NumberModule } from "libraries/module/formbuilder/fields/number/number.module";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { ComboboxFieldModule } from "libraries/module/formbuilder/fields/combobox-field/combobox-field.module";
import { TextModule } from "libraries/module/formbuilder/fields/text/text.module";
import { MatRadioModule } from "@angular/material/radio";
import { ReactiveFormsModule } from "@angular/forms";
import { DateModule } from "libraries/module/formbuilder/fields/date/date.module";
import { TextFieldModule } from "libraries/module/formbuilder/fields/text-field/text-field.module";



@NgModule({
    imports: [
        CommonModule,
        MatDialogModule,
        BtnModule,
        CardModule,
        NumberModule,
        MatButtonToggleModule,
        ComboboxFieldModule,
        TextModule,
        MatRadioModule,
        ReactiveFormsModule,
        DateModule,
        TextFieldModule,
    ],
    exports: [],
    declarations: [
        FareOptimisationRejectFormComponent,
    ],
    providers: [],
})
export class FareOptimisationRejectFormModule {
}
